<template>
	<div  :style="css.container" ref="VisualMedium" id="container">
		<video v-if="!bIsImage" :style="css.media" ref="video" id="video" autoplay muted>
			<source :src="source" type="video/mp4">
			Your browser does not support the video tag.
		</video> 
		<img v-if="bIsImage" :style="css.media" ref="img" id="img" :src="source">
	</div>
</template>

<script>
/* eslint-disable*/
export default {

  name: 'VisualMedium',

  props: {
	source: String,
	css: Object
  },

  data () {
    return {
		hideMedium: {
			true(that){
				that.bIsImage = true;
				//that.$refs.video.style.display = 'none';
				//that.$refs.img.style.display = 'block';
			},
			false(that){
				that.bIsImage = false;
				that.$emit('videostart');
				//that.$refs.img.style.display = 'none';
				//that.$refs.video.style.display = 'block';
				that.$refs.video.src = that.source;
				that.$refs.video.play();
				that.$refs.video.addEventListener('ended', function () {
					that.$emit('videoend');
				});
			}
		},
		bIsImage: true
    }
  },

  mounted() {

  	this.updateMedium();

  },

  methods: {
	updateMedium(){
		const regex = /\.mp4$/;
		this.hideMedium[(this.source.match(regex) == null)](this);
	}
  },

  watch: {
	source(){
		this.updateMedium();
	}
  }

}
</script>

<style lang="css" scoped>
</style>